import * as React from 'react';
import { AutoComplete } from '../../containers/autocomplete/AutoComplete';
import { ApiEndpoints } from '../../utils/app-constants';
import { InputFeedback } from './InputFeedback';
import { InputLabel } from './InputLabel';

// #region Component Props

interface IProps {
    id          : string;
    label       : string;
    value       : any;
    onChange    : any;
    dispatch    : any;
    className?  : string;
    error?      : string;
    disable?    : boolean;
}

// #endregion

const DealerInput : React.SFC<IProps> = (props) => {

    const { className, id, error, label, value, onChange, disable, dispatch } = props;

    return (
        <div className={'form-group ' + (className)}>
            <InputLabel htmlFor={id} error={error}>
                {label}
            </InputLabel>
            <AutoComplete
                id={ id }
                dispatch={ dispatch }
                classList={ error ? 'error-outline' : '' }
                onSelectedCallback={ onChange }
                currentValue={ value ? (value.name ? value.name : value) : '' }
                disabled={ disable ? disable : false }
                placeholder="Type In a Dealer"
                endpoint={ ApiEndpoints.DEALERS_AUTOCOMPLETE }
            />           
            <InputFeedback error={error} />
        </div>
    );
};

DealerInput.defaultProps = {
    className: '',
    error: '',
    disable: false
};

export { DealerInput };
